import React from 'react';
import { cn } from "../../lib/utils"
import { Avatar, AvatarImage } from "./avatar"

export const TestimonialCard = ({ 
  author,
  text,
  href,
  className
}) => {
  const Card = href ? 'a' : 'div'
  
  return (
    <Card
      {...(href ? { href } : {})}
      className={cn(
        "flex flex-col rounded-xl border border-white/10",
        "bg-white/[0.02] backdrop-blur-sm",
        "p-4 text-start sm:p-6",
        "hover:bg-white/[0.05]",
        "w-[320px]",
        "transition-all duration-300",
        className
      )}
    >
      <div className="flex items-center gap-3">
        <Avatar className="h-12 w-12 border border-white/10">
          <AvatarImage src={author.avatar} alt={author.name} />
        </Avatar>
        <div className="flex flex-col items-start">
          <h3 className="text-md font-semibold leading-none text-white">
            {author.name}
          </h3>
          <p className="text-sm text-white/40 mt-1">
            {author.handle}
          </p>
        </div>
      </div>
      <p className="sm:text-md mt-4 text-sm text-white/60 leading-relaxed italic">
        "{text}"
      </p>
    </Card>
  )
}
